import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Container,
  Divider,
  Grid,
} from 'semantic-ui-react';
import NavBar from '../../components/NavBar';
import TemplateList from '../../components/TemplateList';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    return {
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = List.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = List.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('SMS Templates', { ns: TRANSLATION_FILES.translation })}
        />
        <Grid verticalAlign="middle" columns="equal" stackable>
          <Grid.Row>
            <Grid.Column>
              <Divider horizontal>{t('SMS Templates', { ns: TRANSLATION_FILES.translation })}</Divider>
              <TemplateList
                loading={this.state.loading}
                type="sms"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(List);



// WEBPACK FOOTER //
// ./src/containers/SMSTemplates/List.jsx